module.exports = __webpack_public_path__ + "img/hx.5dd50f1e.png";